import { Chip } from '@mui/material';

import { APP_VERSION } from 'config/version';

const VersionChip = () => (
    <Chip label={APP_VERSION} size="small" sx={{ height: 16, '& .MuiChip-label': { fontSize: '0.625rem', py: 0.25 } }} />
);

export default VersionChip;
